import React, { useRef, useEffect, useState } from "react";
import styles from "./UploadOtherInfoMain.module.css";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { useHistory,Link } from "react-router-dom";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";
import { uploadApplicationDocumentsApi } from "../../../config/uploadApplicationDocumentsApi";

function UploadOtherInfoMain(props) {

  useEffect(() => {
        if (props.passportDetails.application !== true) {
          history.push("/dashboard/my-applications");
        } else {
    setId(props.passportDetails.id);
        }

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      setToken(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  const history = useHistory()

  const [id, setId] = useState("");
  const [token, setToken] = useState("");

  const [allBoxes, setAllBoxes] = useState([1]);

  const [uploaded1, setUploaded1] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [image1, setImage1] = useState("");
  const [inputName1, setInputName1] = useState("");
  const imageInput1 = useRef();
  const [imageName1, setImageName1] = useState("");

  const accept = ["png", "jpg", "jpeg", "gif", "docx", "pdf"];

  const handleImage1 = (e) => {
    if (e !== "") {
      const name = e.target.files[0].name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);

      if (accept.includes(ext.toLowerCase())) {
        setImageName1(e.target.files[0].name);
        setImage1(e.target.files[0]);
      }
    } else {
      setImageName1("");
      setImage1("");
    }
  };

  const [uploaded2, setUploaded2] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [image2, setImage2] = useState("");
  const [inputName2, setInputName2] = useState("");
  const imageInput2 = useRef();
  const [imageName2, setImageName2] = useState("");
  const handleImage2 = (e) => {
    if (e !== "") {
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
  
        if (accept.includes(ext.toLowerCase())) {
          setImageName2(e.target.files[0].name);
          setImage2(e.target.files[0]);
        }
      } else {
        setImageName2("");
        setImage2("");
      }
  };

  const [uploaded3, setUploaded3] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [image3, setImage3] = useState("");
  const [inputName3, setInputName3] = useState("");
  const imageInput3 = useRef();
  const [imageName3, setImageName3] = useState("");
  const handleImage3 = (e) => {
    if (e !== "") {
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
  
        if (accept.includes(ext.toLowerCase())) {
          setImageName3(e.target.files[0].name);
          setImage3(e.target.files[0]);
        }
      } else {
        setImageName3("");
        setImage3("");
      }
  };

  const [uploaded4, setUploaded4] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [image4, setImage4] = useState("");
  const [inputName4, setInputName4] = useState("");
  const imageInput4 = useRef();
  const [imageName4, setImageName4] = useState("");
  const handleImage4 = (e) => {
    if (e !== "") {
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
  
        if (accept.includes(ext.toLowerCase())) {
          setImageName4(e.target.files[0].name);
          setImage4(e.target.files[0]);
        }
      } else {
        setImageName4("");
        setImage4("");
      }
  };

  const [uploaded5, setUploaded5] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [image5, setImage5] = useState("");
  const [inputName5, setInputName5] = useState("");
  const imageInput5 = useRef();
  const [imageName5, setImageName5] = useState("");
  const handleImage5 = (e) => {
    if (e !== "") {
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
  
        if (accept.includes(ext.toLowerCase())) {
          setImageName5(e.target.files[0].name);
          setImage5(e.target.files[0]);
        }
      } else {
        setImageName5("");
        setImage5("");
      }
  };
  const addMore = () => {
    if (allBoxes.length < 5) {
      setAllBoxes([...allBoxes, allBoxes.length + 1]);
    } else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Only 5 Inputs Allowed
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
  };

  const imageInput = (value) => {
    if (value === 1) {
      return imageInput1;
    }
    if (value === 2) {
      return imageInput2;
    }
    if (value === 3) {
      return imageInput3;
    }
    if (value === 4) {
      return imageInput4;
    }
    if (value === 5) {
      return imageInput5;
    }
  };

  const imageInputClick = (value) => {
    if (value === 1) {
      return imageInput1.current.click();
    }
    if (value === 2) {
      return imageInput2.current.click();
    }
    if (value === 3) {
      return imageInput3.current.click();
    }
    if (value === 4) {
      return imageInput4.current.click();
    }
    if (value === 5) {
      return imageInput5.current.click();
    }
  };

  const handleImage = (value, e) => {
    if (value === 1) {
      return handleImage1(e);
    }
    if (value === 2) {
      return handleImage2(e);
    }
    if (value === 3) {
      return handleImage3(e);
    }
    if (value === 4) {
      return handleImage4(e);
    }
    if (value === 5) {
      return handleImage5(e);
    }
  };
  const imageName = (value) => {
    if (value === 1) {
      return imageName1;
    }
    if (value === 2) {
      return imageName2;
    }
    if (value === 3) {
      return imageName3;
    }
    if (value === 4) {
      return imageName4;
    }
    if (value === 5) {
      return imageName5;
    }
  };

  const name = (value) => {
    if (value === 1) {
      return inputName1;
    }
    if (value === 2) {
      return inputName2;
    }
    if (value === 3) {
      return inputName3;
    }
    if (value === 4) {
      return inputName4;
    }
    if (value === 5) {
      return inputName5;
    }
  };

  const changeName = (value, e) => {
    if (value === 1) {
      return setInputName1(e);
    }
    if (value === 2) {
      return setInputName2(e);
    }
    if (value === 3) {
      return setInputName3(e);
    }
    if (value === 4) {
      return setInputName4(e);
    }
    if (value === 5) {
      return setInputName5(e);
    }
  };

  const loading = (value) => {
    if (value === 1) {
      return loading1;
    }
    if (value === 2) {
      return loading2;
    }
    if (value === 3) {
      return loading3;
    }
    if (value === 4) {
      return loading4;
    }
    if (value === 5) {
      return loading5;
    }
  };

  const uploaded = (value) => {
    if (value === 1) {
      return uploaded1;
    }
    if (value === 2) {
      return uploaded2;
    }
    if (value === 3) {
      return uploaded3;
    }
    if (value === 4) {
      return uploaded4;
    }
    if (value === 5) {
      return uploaded5;
    }
  };

  const cancel = (value) => {
    if (value !== 1) {
      setAllBoxes(allBoxes.filter((val) => val !== value));
      handleImage(value, "");
      changeName(value, "");
    } else {
      handleImage(value, "");
      changeName(value, "");
    }
  };

  const attach = (value) => {
    if (value === 1) {
      if (image1 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Select File First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else if (inputName1 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Write File Name First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        const upload = async () => {
          setLoading1(true);
          const uploadImage = await uploadApplicationDocumentsApi(
            id,
            token,
            image1,
            inputName1,
            props.passportDetails.document_id
          );

          if (uploadImage.error) {
            setLoading1(false);
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {uploadImage.error.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          } else if (uploadImage.data) {
            setLoading1(false);
            setUploaded1(true);
          }
        };
        upload();
      }
    }
    if (value === 2) {
      if (image2 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Select File First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else if (inputName2 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Write File Name First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        const upload = async () => {
          setLoading2(true);
          const uploadImage = await uploadApplicationDocumentsApi(
            id,
            token,
            image2,
            inputName2,
            props.passportDetails.document_id
          );

          if (uploadImage.error) {
            setLoading2(false);
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {uploadImage.error.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          } else if (uploadImage.data) {
            setLoading2(false);
            setUploaded2(true);
          }
        };
        upload();
      }
    }
    if (value === 3) {
      if (image3 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Select File First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else if (inputName3 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Write File Name First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        const upload = async () => {
          setLoading3(true);
          const uploadImage = await uploadApplicationDocumentsApi(
            id,
            token,
            image3,
            inputName3,
            props.passportDetails.document_id
          );

          if (uploadImage.error) {
            setLoading3(false);
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {uploadImage.error.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          } else if (uploadImage.data) {
            setLoading3(false);
            setUploaded3(true);
          }
        };
        upload();
      }
    }
    if (value === 4) {
      if (image4 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Select File First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else if (inputName4 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Write File Name First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        const upload = async () => {
          setLoading4(true);
          const uploadImage = await uploadApplicationDocumentsApi(
            id,
            token,
            image4,
            inputName4,
            props.passportDetails.document_id
          );

          if (uploadImage.error) {
            setLoading4(false);
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {uploadImage.error.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          } else if (uploadImage.data) {
            setLoading4(false);
            setUploaded4(true);
          }
        };
        upload();
      }
    }
    if (value === 5) {
      if (image5 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Select File First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else if (inputName5 === "") {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            Kindly Write File Name First!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        const upload = async () => {
          setLoading5(true);
          const uploadImage = await uploadApplicationDocumentsApi(
            id,
            token,
            image5,
            inputName5,
            props.passportDetails.document_id
          );

          if (uploadImage.error) {
            setLoading5(false);
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {uploadImage.error.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          } else if (uploadImage.data) {
            setLoading5(false);
            setUploaded5(true);
          }
        };
        upload();
      }
    }
  };
  return (
    <div>
      <div className={styles.mainBox}>
        <h1 className={styles.head}>Upload all other documents here</h1>
        {allBoxes.map((value, index) =>
          uploaded(value) ? (
            <div className={styles.IfUploaded} key={index}>
              <h1 className={styles.fileName}>{imageName(value)}</h1>
              <button class={styles.uploaded}>
                <BsCheckAll size={24} /> Uploaded
              </button>
            </div>
          ) : (
            <div className={styles.inputsAndBtns} key={index}>
              <div className={styles.inputsBox}>
                <input
                  type="text"
                  placeholder="Enter document title"
                  className={styles.input1}
                  value={name(value)}
                  onChange={(e) => changeName(value, e.target.value)}
                />
                <div
                  className={styles.input2}
                  onClick={() => imageInputClick(value)}
                >
                  <div>
                    <input
                      type="file"
                      style={{ display: "none" }}
                      ref={imageInput(value)}
                      accept="image/x-png,image/gif,image/jpeg,application/pdf,application/msword,
                                      application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      onChange={(e) => handleImage(value, e)}
                    />
                  </div>
                  <h1 className={styles.fileName}>{imageName(value)}</h1>
                  <button className={styles.inputEnd}>Choose File</button>
                </div>
              </div>
              <div className={styles.buttonsBox}>
                <button className={styles.btn1} onClick={() => cancel(value)}>
                  Cancel
                </button>
                <button className={styles.btn2} onClick={() => attach(value)}>
                  {loading(value) ? (
                    <div class="spinner-border" role="status"></div>
                  ) : (
                    "Attach file"
                  )}
                </button>
              </div>
            </div>
          )
        )}

        {allBoxes.length < 5 ? (
          <h1 className={styles.addMoreHead} onClick={() => addMore()}>
            + Add more
          </h1>
        ) : null}

        <div className={styles.lastBtnCont}>
            <Link to={`/dashboard/my-applications/${id}/review-application`}>
          <button className={styles.lastBtn}>Review Application</button>
          </Link>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
});

export default connect(mapStateToProps, mapDispatchToProp)(UploadOtherInfoMain);
